import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "q-d-grid q-gap-2 q-col-12 q-mt-2 q-mx-auto more-results__container" }
const _hoisted_2 = {
  key: 0,
  class: "q-spinner-border q-spinner-border-sm q-ms-2",
  role: "status",
  "aria-hidden": "true"
}

import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {storeToRefs} from "pinia"
import {inject} from 'vue';
import {SmartSearchTranslationsInterface} from "@/core/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'MoreResultsButton',
  setup(__props) {

const SmartSearchConfig = inject('SmartSearchConfig').value
const urlStore = useUrlStore()
const popupStore = usePopupStore()


const searchQueryStore = useSearchQueryStore()
const {getSearchQuery} = storeToRefs(searchQueryStore)
const {hasAnyResults, loading} = storeToRefs(popupStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(hasAnyResults))
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "q-btn q-btn-danger q-btn more-results__link",
          tabindex: "-1",
          role: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(urlStore).goToSerpPage(`${_unref(SmartSearchConfig).appConfiguration.redirectionUrl}?q=${_unref(getSearchQuery)}`, _unref(SmartSearchConfig).appConfiguration.redirectionUrl )), ["prevent"]))
        }, [
          _createTextVNode(_toDisplayString(_unref(SmartSearchTranslations).autocomplete.seeMore) + " ", 1),
          (_unref(loading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2))
            : _withDirectives((_openBlock(), _createElementBlock("span", { key: 1 }, " (" + _toDisplayString(_unref(popupStore).getTotalProducts) + ")", 513)), [
                [_vShow, _unref(popupStore).getTotalProducts]
              ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})